import { render } from "./commentsrole.vue?vue&type=template&id=7b00edb2"
import script from "./commentsrole.vue?vue&type=script&lang=js"
export * from "./commentsrole.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__